import { createApp, defineAsyncComponent } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import BaseCard from './components/ui/BaseCard.vue';
import BaseButton from './components/ui/BaseButton.vue';
import BaseSpinner from './components/ui/BaseSpinner.vue';
// import BaseDialog from './components/ui/BaseDialog.vue';
// import BaseMenu from './components/ui/BaseMenu.vue';

const BaseDialog = defineAsyncComponent(() => import('./components/ui/BaseDialog.vue'));
const BaseMenu = defineAsyncComponent(() => import('./components/ui/BaseMenu.vue'));

const app = createApp(App);

app.use(store);

app.component('base-card', BaseCard);
app.component('base-button', BaseButton);
app.component('base-spinner', BaseSpinner);
app.component('base-dialog', BaseDialog);
app.component('base-menu', BaseMenu);

// store.dispatch("loadData").then(() => {
//   store.dispatch("tryLogin").then(() => {
//     store.dispatch("loadRestrictedData").then(() => {
//       app.use(router);
//       app.mount('#app');
//     })
//   })
// })

store.dispatch("tryLogin").then(() => {
  store.dispatch("loadData").then(() => {
    store.dispatch("loadRestrictedData").then(() => {
      app.use(router);
      app.mount('#app');
    })
  })
})

// store.dispatch("tryLogin").then(() => {
//   app.use(router);
//   app.mount('#app');
// })
